module.exports = __webpack_public_path__ + "img/ville-bromont.527b8fbf.webp";